import React from 'react';
import { RPCFactory } from '../../../utils/RequestUtil';

export class NoticeDetail extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      noticeDetail: {},
    };
  }

  getDetail = () => {
    const { noticeId } = this.props;
    RPCFactory.noticeCenter
      .getNoticeDetail({
        noticeId,
      })
      .done((data) => {
        this.setState({ noticeDetail: data });
      });
  };

  componentDidMount() {
    this.getDetail();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.noticeId !== this.props.noticeId) {
      this.getDetail();
    }
  }

  handleClick = () => {
    this.props.hideDialog();
  };

  handleClose = () => {
    this.props.hideDialog();
  };

  render() {
    const { noticeDetail } = this.state;
    const content = (noticeDetail && noticeDetail.content) || '';
    return (
      <div className="with-full-height notice-detail whole-dialog">
        <div className="dialog-header">
          <i
            className="icon icon-close"
            onClick={(e) => {
              this.handleClose();
            }}
          ></i>
        </div>
        <div className="whole-dialog-inner">
          <div className="dialog-title">{noticeDetail.title}</div>
          <div className="dialog-time">{noticeDetail.createTime}</div>
          <div className="dialog-subject">
            <div className="dialog-subject-inner">{noticeDetail.subject ? `摘要：${noticeDetail.subject}` : ''}</div>
          </div>
          <div className="dialog-content">
            <div id="dialog-content-inner" dangerouslySetInnerHTML={{ __html: content }}></div>
          </div>
          {noticeDetail.attachments && noticeDetail.attachments.length && (
            <div className="dialog-attachments">
              {noticeDetail.attachments.map((attachment) => (
                <div className="dialog-attachment">
                  <a href={attachment.url}>附件：{attachment.title}</a>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}
